<template>
  <PlayerPage :loading="loading" :white="false"
      :displayLog="displayLog" @displayLog="displayLog = $event">
    <title-bar>TV</title-bar>
    <div class="log-ctrl">
      <div></div>
      <b-button class="close" variant="danger" @click="displayLog = false">
        <b-icon icon="x" />
      </b-button>
    </div>
    <story-note :code="code"></story-note>
    <a v-if="$store.getters.recorder"
      :href="$store.getters.recorder"
    >Download</a>
  </PlayerPage>
</template>

<script>
import { phina, canvasInit } from '@/canvas'
import store from '@/store'
import PlayerPage from '@/components/PlayerPage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import StoryNote from '@/components/StoryNote'
export default {
  components: {
    PlayerPage,
    TitleBar,
    StoryNote
  },
  computed: {
    // code () {
    //   return this.$store.getters.currentCode
    // }
  },
  data () {
    return {
      nickname: '',
      loading: false,
      displayLog: true,
      code: []
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.nickname = response.nickname
      this.$store.dispatch('setCode', response.code)

      phina.global.app.one('started', ()=>{
        // eslint-disable-next-line
        phina.global.app.pushScene(RequestScene({
          assets: response.assets,
          success: (_response, args)=>{
            this.code = response.code
            args.$extend(response)
              .$extend({ store:this.$store, bg:'img/ui/bg.png' });
            return 'StoryScene'
          }
        }))
      })
    }
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getTvLog')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
  created () {
    // this.checkLogin()
    this.$store.dispatch('setCode', [])
  },
  mounted () {
    phina.main(canvasInit);
    this.$store.dispatch('setCode', [])
    this.$store.dispatch('setThreadPosition', 'right')
    // phina.global.app.currentScene.exit('TitleScene')
  },
  destroyed () {
    this.$store.dispatch('setRecorder', null);
    this.$store.dispatch('setThreadPosition', 'center')
  }
}
</script>

<style lang="scss" scoped>
.log-ctrl {
  width: 100%;
  pointer-events: visible;
  display: flex;
  justify-content: space-between;
}
</style>
